import api from "@/lib/api";
import { toast } from "sonner";

async function readErrorDetail(e) {
  const data = e?.response?.data;
  if (!data) return e?.message || "";
  // Con responseType blob, el cuerpo del error también llega como Blob.
  if (typeof data === "string") return data;
  if (typeof data?.text === "function") {
    try {
      const txt = await data.text();
      try {
        const j = JSON.parse(txt);
        return typeof j.detail === "string" ? j.detail : txt.slice(0, 300);
      } catch {
        return txt.slice(0, 300);
      }
    } catch {
      return "";
    }
  }
  return typeof data.detail === "string" ? data.detail : "";
}

export async function downloadXlsx(path, fallbackName = "export.xlsx") {
  const isPdf = /format=pdf/.test(path) || fallbackName.endsWith(".pdf");
  const kind = isPdf ? "PDF" : "Excel";
  try {
    const res = await api.get(path, { responseType: "blob" });
    const blob = new Blob([res.data], {
      type: res.headers["content-type"] || (isPdf ? "application/pdf" : "application/octet-stream"),
    });
    if (!blob.size) {
      toast.error(`El ${kind} llegó vacío. Vuelve a intentarlo.`);
      return;
    }
    const cd = res.headers["content-disposition"] || "";
    let filename = fallbackName;
    const m = /filename="?([^";]+)"?/.exec(cd);
    if (m && m[1]) filename = m[1];
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    // Safari/iOS antiguos ignoran el atributo download: en ese caso abrimos
    // el fichero en una pestaña nueva para que el usuario lo guarde.
    if (typeof a.download === "undefined") {
      window.open(url, "_blank");
      setTimeout(() => window.URL.revokeObjectURL(url), 20000);
      return;
    }
    a.href = url;
    a.download = filename;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 4000);
  } catch (e) {
    const status = e?.response?.status;
    const detail = await readErrorDetail(e);
    const extra = detail ? ` · ${detail}` : "";
    toast.error(`No se pudo descargar el ${kind}${status ? ` (error ${status})` : ""}${extra}`);
    console.error("[download]", path, status, detail || e);
  }
}
